export default "__VITE_ASSET__Dqs2QRCv__"